import { FC } from 'react'

import { TextPromo } from 'components/ui'
import { Space } from 'components/ui/Space/Space'
import { useResize } from 'utils/hooks/useResize'

import { SupportCard } from './components/SupportCard/SupportCard'
import { supportCardsText } from './data'

import s from './OpeningSteps.module.scss'

export const OpeningSteps: FC = () => {
  const { isMobile, isTablet } = useResize()

  return (
    <section className={s.section}>
      <div className={`contentWrapper ${s.openingSteps}`}>
        <div className={s.title}>
          <Space size={!isTablet ? 100 : 54} />
          <TextPromo center weight="w700" size={isTablet ? (isMobile ? 's32' : 's40') : 's70'}>
            Поддержим
          </TextPromo>
          <TextPromo center weight="w700" size={isTablet ? (isMobile ? 's32' : 's40') : 's70'}>
            не словом, а&nbsp;делом
          </TextPromo>
        </div>

        <Space size={isTablet ? (isMobile ? 24 : 40) : 64} />

        <div className={s.supportSteps}>
          {supportCardsText.map((card) => (
            <SupportCard key={card.id} card={card} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default OpeningSteps
